import PropTypes from 'prop-types';
import { FINAL_SALE } from '../../config/constants';
import Afterpay from '../../components/Afterpay';
import css from './AddToBag.module.scss';
import CTA from './CTA';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var AddToBag = function AddToBag(_ref) {
  var available = _ref.available,
      finalSale = _ref.finalSale,
      compareAtPrice = _ref.compareAtPrice,
      comingSoon = _ref.comingSoon,
      displayWaitlist = _ref.displayWaitlist,
      onAddToBag = _ref.onAddToBag,
      onShowWaitlist = _ref.onShowWaitlist,
      price = _ref.price,
      submitting = _ref.submitting,
      title = _ref.title;
  return /*#__PURE__*/_jsxs("section", {
    className: css.root,
    children: [finalSale && /*#__PURE__*/_jsx("div", {
      className: css.shippingMessage,
      children: /*#__PURE__*/_jsx("span", {
        className: css.finalSale,
        children: FINAL_SALE
      })
    }), /*#__PURE__*/_jsx(CTA, {
      available: available,
      comingSoon: comingSoon,
      compareAtPrice: compareAtPrice,
      displayWaitlist: displayWaitlist,
      price: price,
      onShowWaitlist: onShowWaitlist,
      onAddToBag: onAddToBag,
      submitting: submitting,
      title: title
    }), available && /*#__PURE__*/_jsx("div", {
      className: css.afterpay,
      children: /*#__PURE__*/_jsx(Afterpay, {
        price: price
      })
    })]
  });
};

AddToBag.defaultProps = {
  submitting: false
};
AddToBag.propTypes = {
  available: PropTypes.bool.isRequired,
  finalSale: PropTypes.bool,
  compareAtPrice: PropTypes.number.isRequired,
  comingSoon: PropTypes.bool.isRequired,
  displayWaitlist: PropTypes.bool.isRequired,
  onAddToBag: PropTypes.func.isRequired,
  onShowWaitlist: PropTypes.func.isRequired,
  price: PropTypes.number.isRequired,
  shopifyId: PropTypes.number.isRequired,
  submitting: PropTypes.bool,
  title: PropTypes.string
};
export default AddToBag;